var _defs, _g, _rect, _rect2, _g2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 197.439,
    height: 112.999,
    viewBox: "0 0 197.439 112.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282",
    "data-name": "Rectangle 3282",
    width: 15.236,
    height: 15.236,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3282-2",
    "data-name": "Rectangle 3282",
    width: 10.158,
    height: 10.158,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.574,
    y1: 0.623,
    x2: 0,
    y2: -0.085,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.5,
    x2: -0.268,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.14,
    y1: 0.5,
    x2: 0.456,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1.064,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35876",
    "data-name": "Group 35876",
    transform: "translate(-8197.5 2519.998)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28773",
    "data-name": "Group 28773",
    transform: "translate(8208.926 -2519.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102",
    "data-name": "Path 38102",
    d: "M10.186,5.569l4.5,1.316a.763.763,0,0,1,0,1.465l-4.5,1.316a.764.764,0,0,0-.519.518l-1.316,4.5a.763.763,0,0,1-1.465,0l-1.316-4.5a.763.763,0,0,0-.518-.518L.55,8.35a.763.763,0,0,1,0-1.465l4.5-1.316A.763.763,0,0,0,5.57,5.05L6.886.549a.763.763,0,0,1,1.465,0l1.316,4.5a.764.764,0,0,0,.519.518",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 10.467,
    height: 10.467,
    rx: 2.64,
    transform: "translate(8254.187 -2468.336) rotate(-30)",
    fill: "#fff369"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 10.467,
    height: 10.467,
    rx: 2.64,
    transform: "translate(8232.957 -2486.154) rotate(-45)",
    fill: "#c89b00"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_28772",
    "data-name": "Group 28772",
    transform: "translate(8268.481 -2498.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28771-2",
    "data-name": "Group 28771",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38102-2",
    "data-name": "Path 38102",
    d: "M6.791,3.712l3,.878a.509.509,0,0,1,0,.977l-3,.878a.509.509,0,0,0-.346.346l-.878,3a.509.509,0,0,1-.977,0l-.878-3a.509.509,0,0,0-.346-.346l-3-.878a.509.509,0,0,1,0-.977l3-.878a.509.509,0,0,0,.346-.346l.878-3a.509.509,0,0,1,.977,0l.878,3a.509.509,0,0,0,.346.346",
    transform: "translate(-0.001 0)",
    fill: "#1c1c1c"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 10.467,
    height: 10.467,
    rx: 2.64,
    transform: "translate(8197.5 -2466.673) rotate(-45)",
    fill: "#fc3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39514",
    "data-name": "Path 39514",
    d: "M23.967,42.933A13.967,13.967,0,1,1,37.933,28.967,13.982,13.982,0,0,1,23.967,42.933Zm0-20.315a6.348,6.348,0,1,0,6.348,6.348A6.356,6.356,0,0,0,23.967,22.618Z",
    transform: "translate(8331.61 -2449.932)",
    fill: "#fc3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39515",
    "data-name": "Path 39515",
    d: "M16.963,21.86A3.81,3.81,0,0,1,13.8,15.938l6.211-9.32H6.809A3.809,3.809,0,0,1,6.809-1H27.124a3.809,3.809,0,0,1,3.17,5.921L20.136,20.163A3.806,3.806,0,0,1,16.963,21.86Z",
    transform: "translate(8303.061 -2515.191)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39516",
    "data-name": "Path 39516",
    d: "M60.676,38.9H4.809A3.809,3.809,0,0,1,1.4,33.39L11.561,13.11a3.809,3.809,0,0,1,6.812,3.412l-7.4,14.765h49.7a3.809,3.809,0,1,1,0,7.618Z",
    transform: "translate(8294.899 -2466.217)",
    fill: "#fc3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39517",
    "data-name": "Path 39517",
    d: "M72.833,55.327H6.809a3.809,3.809,0,0,1,0-7.618H70.088l12.7-38.091H16.967a3.809,3.809,0,0,1,0-7.618h71.1a3.809,3.809,0,0,1,3.614,5.014L76.447,52.723A3.809,3.809,0,0,1,72.833,55.327Z",
    transform: "translate(8303.061 -2502.956)",
    fill: "#fc3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_502",
    "data-name": "Line 502",
    d: "M41.439,4.618H.809A3.809,3.809,0,0,1,.809-3h40.63a3.809,3.809,0,0,1,0,7.618Z",
    transform: "translate(8298.899 -2482.719)",
    fill: "#fc3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_503",
    "data-name": "Line 503",
    d: "M41.439,4.618H.809A3.809,3.809,0,0,1,.809-3h40.63a3.809,3.809,0,0,1,0,7.618Z",
    transform: "translate(8288.747 -2467.482)",
    fill: "url(#linear-gradient-2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line_502-2",
    "data-name": "Line 502",
    d: "M41.439,4.618H.809A3.809,3.809,0,0,1,.809-3h40.63a3.809,3.809,0,0,1,0,7.618Z",
    transform: "translate(8298.899 -2482.719)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35874",
    "data-name": "Group 35874",
    transform: "translate(8285.747 -2434.932)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39513",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Z",
    transform: "translate(1 -15)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39513-2",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Zm0-20.315a6.348,6.348,0,1,0,6.348,6.348A6.356,6.356,0,0,0,12.967,22.618Z",
    transform: "translate(1 -15)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39513-3",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Zm0-20.315a6.348,6.348,0,1,0,6.348,6.348A6.356,6.356,0,0,0,12.967,22.618Z",
    transform: "translate(1 -15)",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35875",
    "data-name": "Group 35875",
    transform: "translate(8341.61 -2434.932)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39513-4",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Z",
    transform: "translate(1 -15)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39513-5",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Zm0-20.315a6.348,6.348,0,1,0,6.348,6.348A6.356,6.356,0,0,0,12.967,22.618Z",
    transform: "translate(1 -15)",
    fill: "#fc3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39513-6",
    "data-name": "Path 39513",
    d: "M12.967,42.933A13.967,13.967,0,1,1,26.933,28.967,13.982,13.982,0,0,1,12.967,42.933Zm0-20.315a6.348,6.348,0,1,0,6.348,6.348A6.356,6.356,0,0,0,12.967,22.618Z",
    transform: "translate(1 -15)",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activate-icon.64de3b80f63bd73df9a6e3ca010a282c.svg";
export { ForwardRef as ReactComponent };